import {
  ATCT_MODEL_TYPES,
  BRIDGE_MODEL_TYPES,
  CELL_TOWER_MODEL_TYPES,
  POWER_LINE_MODEL_TYPES,
} from '@App/app/configs/models.config';
import { ModelTypeConfig, totalAreaInput } from './model-type-params.types';

export const dataTypeParametersA: Record<string, ModelTypeConfig> = {
  ATCT: {
    subTypeName: 'atct',
    modelTypes: ATCT_MODEL_TYPES,
    params: [
      {
        title: 'Total height',
        formControlName: 'totalHeight',
        inputType: 'number',
      },
      {
        title: 'Shaft height',
        formControlName: 'shaftHeight',
        inputType: 'number',
      },
      totalAreaInput(),
      {
        title: 'Cab area',
        formControlName: 'cabArea',
        inputType: 'number',
      },
      {
        title: 'Base area',
        formControlName: 'baseArea',
        inputType: 'number',
      },
    ],
    types: {
      VRF_TOWER: 'vfr-tower',
      NRA_TOWER: 'nra-tower',
      RA_TOWER: 'ra-tower',
    },
  },

  CELL_TOWER: {
    subTypeName: 'cell-tower',
    modelTypes: CELL_TOWER_MODEL_TYPES,
    params: [
      {
        title: 'Top steel',
        formControlName: 'topSteel',
        inputType: 'number',
      },
      {
        title: 'Lightning rod',
        formControlName: 'lightningRod',
        inputType: 'number',
      },
      {
        title: 'Highest Appurtenance',
        formControlName: 'highestAppurtenance',
        inputType: 'number',
      },
      {
        title: 'Rad Centers',
        formControlName: 'radCenters',
        isRadCenterInput: true,
      },
    ],
    types: {
      MONOPOLE: 'monopole',
      SELF_SUPPORT: 'self-support',
      GUYED: 'guyed',
    },
  },

  POWER_LINE: {
    subTypeName: 'power-line',
    modelTypes: POWER_LINE_MODEL_TYPES,
    params: [
      {
        title: 'Height',
        formControlName: 'height',
        inputType: 'number',
      },
      {
        title: 'Line Length',
        formControlName: 'lineLength',
        inputType: 'number',
      },
      totalAreaInput(),
    ],
    types: {
      HIGH_VOLTAGE: 'high-voltage',
      MEDIUM_VOLTAGE: 'medium-voltage',
      LOW_VOLTAGE: 'low-voltage',
    },
  },
  BRIDGE: {
    subTypeName: 'bridge',
    modelTypes: BRIDGE_MODEL_TYPES,
    params: [
      {
        title: 'Length',
        formControlName: 'length',
        inputType: 'number',
      },
      {
        title: 'Width',
        formControlName: 'width',
        inputType: 'number',
      },
      totalAreaInput(),
      {
        title: 'Paved area',
        formControlName: 'pavedArea',
        inputType: 'number',
      },
      {
        title: 'Parapets length',
        formControlName: 'parapetsLength',
        inputType: 'number',
      },
      {
        title: 'Edge Beam length',
        formControlName: 'edgeBeamLength',
        inputType: 'number',
      },
      {
        title: 'Bearings',
        formControlName: 'bearings',
        inputType: 'number',
      },
    ],
    types: {
      SMALL_SPAN: 'small-span',
      MEDIUM_SPAN: 'medium-span',
      LONG_SPAN: 'long-span',
    },
  },
};
